<template>
    <div class="modal-card card">
        <form @submit.prevent="onCreateSandbox()">
        <div class="card-header">
            <!-- Title -->
            <h4 class="card-header-title">
                Create Sandbox
            </h4>
            <!-- Close -->
            <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
            ></button>
        </div>
        <div class="card-body">
                <form-fields :fields="sandboxfields" v-model="sandBox" />
                <div v-if="error" class="text-danger">
                    {{error}}
                </div>
        </div>
        <div class="card-footer">
            <div class="text-end">
                <submit-button :fields="sandboxfields" v-model="sandBox" :loading="loading"/>
            </div>
        </div>
        </form>
    </div>
</template>

<script>
import formFields from '../FormFields.vue';
import submitButton from '../SubmitButton.vue'
import {mapActions, mapState} from 'vuex'
import getSandboxFields from "../../utils/field-constants/sandboxCreateFields"
export default {
    components: { formFields, submitButton },
    data(){        
        return {
            error: "",
            sandBox: {},            
            sandboxfields: [],
            loading: false,
            sandboxJobKinds:["TRANSFORM"]
        }
    },
    name: "AddSandbox",  
    async created(){
        this.sandboxfields = getSandboxFields(); 
        await this.fetchJobKinds();     
        this.sandboxfields = this.sandboxfields.map((field)=>{
            if(field.name =="enabled_job_kinds"){
                field.options= this.jobKindOption
            }
            return field;
        });
    }, 
    computed: { 
        ...mapState({
            jobKinds: (state) => state.amdp.jobKinds,
        }),
        jobKindOption(){
            let jobKindOptions = this.jobKinds.map((jobKind)=> {
                let name = jobKind.name.charAt(0).toUpperCase() + jobKind.name.slice(1);
                this.sandboxJobKinds.push(name.toUpperCase());
                return { label:name, value: name.toUpperCase() } 
            });
            //there is issue, till it getting resolved need this TRANSFORM hardcoded -aMDP team
            jobKindOptions.push({label:"transform",value:"TRANSFORM"});
            return jobKindOptions;
        }
    },
    watch:{
        "sandBox.all_job_kind":{
            handler( newVal,oldVal){
                if(newVal !=="" && Array.isArray(newVal)){
                    if (newVal.toString()=== "all"){
                        this.sandBox.enabled_job_kinds= this.sandboxJobKinds;
                    }else{
                        this.sandBox.enabled_job_kinds= [];
                    }
                }
            }
        },
        "sandBox.enabled_job_kinds":{
            handler( newVal,oldVal){
                if(newVal.length !== this.sandboxJobKinds.length){
                    this.sandBox.all_job_kind=""; //to denote the change is not from checkbox, else deselect all will happen
                }
            }
        }
    },
    methods: {
        ...mapActions({
            createSandbox: "sandbox/createSandbox",
            fetchJobKinds: "amdp/fetchJobKinds",
        }),
        async onCreateSandbox() {
            this.loading = true;
            try {
                let sandbox = JSON.parse(JSON.stringify(this.sandBox));
                sandbox.all_job_kind =sandbox?.all_job_kind || ""
                if(sandbox?.all_job_kind.toString() === "all"){
                    sandbox.enabled_job_kinds =['*', 'TRANSFORM']
                }
                delete sandbox.all_job_kind
                await this.createSandbox(sandbox)
            } catch (error) {                
                if (error.response.data.error) 
                    this.error = error.response.data.error
                else 
                    this.error = error.message
                
                return
            } finally {
                this.loading = false;
            }
            

            this.$store.dispatch('hideModal');
            this.$router.push(`/${this.$store.state.currentClient.cid}/amdp/sandboxes/${this.sandBox.name}`);
        }
    }
};
</script>

<style>
</style>